export let DEVICES = /*#__PURE__*/function (DEVICES) {
  DEVICES["smallMobile"] = "smallMobile";
  DEVICES["mediumMobile"] = "mediumMobile";
  DEVICES["largeMobile"] = "largeMobile";
  DEVICES["tablet"] = "tablet";
  DEVICES["desktop"] = "desktop";
  DEVICES["largeDesktop"] = "largeDesktop";
  return DEVICES;
}({});
export let QUERIES = /*#__PURE__*/function (QUERIES) {
  QUERIES["MEDIUMMOBILE"] = "mediumMobile";
  QUERIES["LARGEMOBILE"] = "largeMobile";
  QUERIES["TABLET"] = "tablet";
  QUERIES["DESKTOP"] = "desktop";
  QUERIES["LARGEDESKTOP"] = "largeDesktop";
  return QUERIES;
}({});